export default "__VITE_ASSET__3KtlNwWk__"